import Vue from 'vue'
import Router from 'vue-router'
import JwtService from './data/jwt.service'
import CStorage from "./data/CStorage";
import userApi from "./data/UserApi";
import {androidRouterBeforeEach} from "./data/AndroidApi";

const AuthLayout = () => import('@/layout/AuthLayout')
const CourseLayout = () => import('./layout/CourseLayout')
const SiteLayout = () => import('./layout/' + Vue.prototype.$flavorConfig.siteLayout)

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.VUE_APP_PUBLIC_PATH,
    linkExactActiveClass: 'active',
    scrollBehavior(to, from, savedPosition) {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                if (savedPosition) {
                    resolve(savedPosition);
                } else {
                    resolve({x: 0, y: 0});
                }
            }, 600);
        });
    },
    routes: [
        {
            path: '/',
            redirect: '/courses',
            component: CourseLayout,
            children: [
                {
                    path: '/course/:slug',
                    props: true,
                    name: 'course',
                    component: () => import('./views/Course.vue')
                },
                {
                    path: '/course/:slug/details',
                    props: true,
                    name: 'course.details',
                    component: () => import('./views/CourseDetails.vue')
                },
                {
                    path: '/course/:id/addpack',
                    props: true,
                    name: 'course.addpack',
                    component: () => import('./views/AddPack.vue')
                },
                {
                    path: '/lesson/:id',
                    props: true,
                    name: 'lesson',
                    component: () => import('./views/Lesson.vue')
                },
                {
                    path: '/lesson/:id/test/:testId',
                    props: true,
                    name: 'LessonTest',
                    component: () => import('./views/Lesson.vue')
                },
                {
                    path: '/lesson/:id/tab/:tabId',
                    props: true,
                    name: 'LessonTab',
                    component: () => import('./views/Lesson.vue')
                },
                {
                    path: '/exam/:id',
                    props: true,
                    name: 'Exam',
                    component: () => import('./views/Exam.vue')
                },
                {
                    path: '/exam/:id/test/:testId',
                    props: true,
                    name: 'ExamTest',
                    component: () => import('./views/Exam.vue')
                },
                // {
                //     path: 'user/profile',
                //     name: 'profile',
                //     component: () => import('./views/UserProfile.vue')
                // },
                {
                    path: 'user/password',
                    name: 'password',
                    component: () => import('./views/UserPassword.vue')
                },
                {
                    path: 'user/remove',
                    name: 'remove',
                    component: () => import('./views/UserRemove.vue')
                },
                {
                    path: 'user/logout',
                    name: 'logout',
                    component: () => import('./views/UserLogout.vue')
                },
            ]
        },
        {
            path: '/',
            redirect: 'course',
            component: SiteLayout,
            children: [
                {
                    path: '/courses',
                    props: true,
                    name: 'courses',
                    component: () => import('./views/CourseList.vue')
                },
                {
                    path: '/order/:idcourse',
                    name: 'order',
                    props: true,
                    component: () => import('./views/Order.vue')
                },
                {
                    path: '/payment/:idcourse',
                    name: 'payment',
                    props: true,
                    component: () => import('./views/Payment.vue')
                },
                {
                    path: '/paymentstatus/:user_payment_id',
                    name: 'paymentstatus',
                    props: true,
                    component: () => import('./views/PaymentStatus.vue')
                },
                {
                    path: '/subscription/order/:id',
                    name: 'order-subscription',
                    props: true,
                    component: () => import('./views/Subscriptions/Order.vue')
                },
                {
                    path: '/subscription/order/:id/:timetableId',
                    name: 'order-subscription-timetableId',
                    props: true,
                    component: () => import('./views/Subscriptions/Order.vue')
                },
                {
                    path: '/subscription/payment/:id',
                    name: 'payment-subscription',
                    props: true,
                    component: () => import('./views/Subscriptions/Payment.vue')
                },
                {
                    path: '/subscription/payment/:id/:timetableId',
                    name: 'payment-subscription-timetableId',
                    props: true,
                    component: () => import('./views/Subscriptions/Payment.vue')
                },
                {
                    path: '/certificate/order/:id',
                    name: 'order-certificate',
                    props: true,
                    component: () => import('./views/Certificate/Order.vue')
                },
                {
                    path: '/certificate/payment/:id',
                    name: 'payment-certificate',
                    props: true,
                    component: () => import('./views/Certificate/Payment.vue')
                },
                {
                    path: '/schedule',
                    name: 'schedule',
                    props: false,
                    component: () => import('./views/Timetables.vue')
                },
                {
                    path: '/schedule/:id',
                    name: 'scheduleId',
                    props: true,
                    component: () => import('./views/Timetables.vue')
                },
                {
                    path: '/schedule/min/:minAge/max/:maxAge',
                    name: 'scheduleLangAge',
                    props: true,
                    component: () => import('./views/Timetables.vue')
                },
                {
                    path: '/schedule/lang/:lang',
                    name: 'scheduleLang',
                    props: true,
                    component: () => import('./views/Timetables.vue')
                },
                {
                    path: '/schedule/lang/:lang/min/:minAge/max/:maxAge',
                    name: 'scheduleAge',
                    props: true,
                    component: () => import('./views/Timetables.vue')
                },
                {
                    path: '/anglijskij-onlajn-v-gruppe',
                    name: 'anglijskij-onlajn-v-gruppe',
                    component: () => import('./views/AnglijskijOnlajnVGruppe.vue')
                },
                {
                    path: '/anglijskij-onlajn-individualno',
                    name: 'anglijskij-onlajn-individualno',
                    component: () => import('./views/AnglijskijOnlajnIndividualno.vue')
                },
                {
                    path: '/german-for-beginners',
                    name: 'german-for-beginners',
                    component: () => import('./views/GermanforBeginners.vue')
                },
                {
                    path: '/individual',
                    name: 'individual',
                    component: () => import('./views/Individual.vue')
                },
                {
                    path: '/godovoj-kurs-anglijskogo-yazyka',
                    name: 'godovoj-kurs-anglijskogo-yazyka',
                    component: () => import('./views/GodovojKursAnglijskogo.vue')
                },
                {
                    path: '/godovoj-kurs-ispanskogo-yazyka',
                    name: 'godovoj-kurs-ispanskogo-yazyka',
                    component: () => import('./views/GodovojKursIspanskogoYazyka.vue')
                },
                {
                    path: '/polugodovoj-kurs-mnemotexnika',
                    name: 'polugodovoj-kurs-mnemotexnika',
                    component: () => import('./views/PolugodovojKursMnemotexnika.vue')
                },
                {
                    path: '/godovoj-kurs-skorochteniya',
                    name: 'godovoj-kurs-skorochteniya',
                    component: () => import('./views/GodovojKursSkorochteniya.vue')
                },
                {
                    path: '/godovoj-kurs-anglijskij-s-rozhdeniya',
                    name: 'godovoj-kurs-anglijskij-s-rozhdeniya',
                    component: () => import('./views/GodovojkursAnglijskijsRozhdeniya.vue')
                },
                {
                    path: '/informacionnaya-peregruzka',
                    name: 'informacionnaya-peregruzka',
                    component: () => import('./views/InformacionnayaPeregruzka.vue')
                },
                {
                    path: '/preschool-english-1',
                    name: 'preschool-english-1',
                    component: () => import('./views/PreschoolEnglish1.vue')
                },
                {
                    path: '/preschool-english-2',
                    name: 'preschool-english-2',
                    component: () => import('./views/PreschoolEnglish2.vue')
                },
                {
                    path: '/primary-school-english-1',
                    name: 'primary-school-english-1',
                    component: () => import('./views/PrimarySchoolEnglish1.vue')
                },
                {
                    path: '/index',
                    name: 'index',
                    component: () => import('./views/index.vue')
                },
                {
                    path: '/onlineteacher',
                    name: 'onlineteacher',
                    props: false,
                    component: () => import('./views/OnlineTeacher.vue')
                },
                {
                    path: '/entry',
                    name: 'entry',
                    props: false,
                    component: () => import('./views/Entry.vue')
                },
                {
                    path: '/exams',
                    name: 'exams',
                    props: false,
                    component: () => import('./views/ExamList.vue')
                },
                {
                    path: '/gift',
                    name: 'gift',
                    props: true,
                    component: () => import('./views/Gift/Gift.vue')
                },
                {
                    path: '/studies',
                    props: true,
                    name: 'studies',
                    component: () => import('./views/Study/StudyList.vue')
                },
                {
                    path: '/try-free',
                    props: true,
                    name: 'try-free',
                    component: () => import('./views/Study/Free.vue')
                },
                {
                    path: '/:slug/order',
                    props: true,
                    name: 'study.order',
                    component: () => import('./views/Study/Prolong.vue')
                },
                {
                    path: '/study/:id',
                    name: 'study',
                    props: true,
                    component: () => import('./views/Study/Study.vue')
                },

                // profile
                {
                    path: '/user/profile',
                    component: () => import('./views/profile/Wrapper.vue'),
                    children: [
                        {
                            path: '',
                            name: 'profile.edit',
                            component: () => import('./views/profile/edit/Edit.vue')
                        },
                        {
                            path: '/user/profile/phone',
                            name: 'profile.confirm.phone',
                            props: true,
                            component: () => import('./views/profile/edit/ConfirmPhone.vue')
                        },
                        {
                            path: '/user/profile/email',
                            name: 'profile.confirm.email',
                            props: true,
                            component: () => import('./views/profile/edit/ConfirmEmail.vue')
                        },
                        {
                            path: 'students',
                            name: 'profile.students',
                            component: () => import('./views/profile/student/Browse.vue')
                        },
                        {
                            path: 'courses',
                            name: 'profile.courses',
                            component: () => import('./views/profile/course/Browse.vue')
                        },
                        {
                            path: 'timetables',
                            name: 'profile.timetables',
                            component: () => import('./views/profile/timetable/Browse.vue')
                        },
                        {
                            path: '/user/profile/timetables/:id',
                            name: 'profileScheduleId',
                            props: true,
                            component: () => import('./views/profile/timetable/Detail.vue')
                        },
                        {
                            path: '/go',
                            name: 'go',
                            props: false,
                            component: () => import('./views/profile/timetable/Go.vue')
                        },
                        {
                            path: '/check',
                            name: 'check',
                            props: false,
                            component: () => import('./views/profile/timetable/Check.vue')
                        },
                        {
                            path: '/user/profile/timetables/rate/:lessonId',
                            name: 'rateLesson',
                            props: true,
                            component: () => import('./views/profile/timetable/Rate.vue')
                        },
                        {
                            path: 'exams',
                            name: 'profile.exams',
                            component: () => import('./views/profile/exams/Browse.vue')
                        },
                        {
                            path: 'studies',
                            name: 'profile.studies',
                            component: () => import('./views/profile/study/Browse.vue')
                        },
                        {
                            path: 'ref-orders',
                            name: 'profile.ref-orders',
                            component: () => import('./views/profile/referal/Browse.vue')
                        },
                        {
                            path: 'myrefid',
                            name: 'profile.fromRefID',
                            component: () => import('./views/profile/referal/FromRefID.vue')
                        },
                        {
                            path: 'medals',
                            name: 'profile.medals',
                            component: () => import('./views/profile/medals/Browse.vue')
                        },
                        {
                            path: 'map',
                            name: 'profile.map',
                            component: () => import('./views/profile/map/Browse.vue')
                        },
                    ]
                },
            ]
        },
        {
            path: '/',
            redirect: 'user/login',
            component: AuthLayout,
            children: [
                {
                    path: 'user/login',
                    name: 'login',
                    component: () => import('./views/UserLogin.vue')
                },
                {
                    path: 'user/register',
                    name: 'register',
                    component: () => import('./views/UserRegister.vue')
                },
                {
                    path: 'user/recovery',
                    name: 'recovery',
                    component: () => import('./views/UserRecoverySimple.vue') //component: () => import('./views/UserRecovery.vue')
                },
                {
                    path: 'user/signin',
                    name: 'login-register',
                    component: () => import('./views/UserLoginRegister.vue')
                },
            ]
        },
        {
            path: '/',
            component: CourseLayout,
            children: [
                {
                    path: 'games/polijump',
                    name: 'polijump',
                    component: () => import('./views/games/PoliJump')
                },
            ]
        },
        {path: '*', component: () => import('./views/PageNotFound.vue')}
    ]
})

router.beforeEach((to, from, next) => {
    //сохраняем локально UTM метки, если они есть в параметрах
    let toUrl = new URL(process.env.VUE_APP_URL + '/home-teacher' + to.fullPath)
    let fromUrl = new URL(process.env.VUE_APP_URL + '/home-teacher' + from.fullPath)
    let toParams = new URLSearchParams(toUrl.search);
    let fromParams = new URLSearchParams(fromUrl.search);
    let utmSourceTo = toParams.has("utm_source") ? toParams.get("utm_source") : ''
    let utmSourceFrom = fromParams.has("utm_source") ? fromParams.get("utm_source") : ''
    let utmCampaignTo = toParams.has("utm_campaign") ? toParams.get("utm_campaign") : ''
    let utmCampaignFrom = fromParams.has("utm_source") ? fromParams.get("utm_campaign") : ''
    if (utmSourceFrom || utmCampaignFrom) {
        CStorage.setItem("utm_source", utmSourceFrom)
        CStorage.setItem("utm_campaign", utmCampaignFrom)
    } else if (utmSourceTo || utmCampaignTo) {
        CStorage.setItem("utm_source", utmSourceTo)
        CStorage.setItem("utm_campaign", utmCampaignTo)
    }

    // redirect to login page if not logged in and trying to access a restricted page
    const publicRoutes = [
        'login', 'register', 'recovery', 'login-register',
        'course', 'courses', 'course.details',
        'schedule', 'scheduleId', 'scheduleLangAge', 'scheduleLang', 'scheduleAge',
        'onlineteacher', 'entry', 'individual', 'gift',
        'anglijskij-onlajn-v-gruppe', 'german-for-beginners',
        'preschool-english-1', 'preschool-english-2', 'primary-school-english-1', 'index',
        'anglijskij-onlajn-individualno',
        'lesson',
        'order', 'order-certificate', 'order-subscription', 'order-subscription-timetableId',
        'studies', 'study',
        'godovoj-kurs-anglijskogo-yazyka', 'godovoj-kurs-ispanskogo-yazyka', 'godovoj-kurs-skorochteniya', 'godovoj-kurs-anglijskij-s-rozhdeniya', 'polugodovoj-kurs-mnemotexnika',
        'informacionnaya-peregruzka',
        'try-free', 'study.order',
        'polijump'
    ]

    const authRequired = to.name && !publicRoutes.includes(to.name)
    const loggedIn = JwtService.isAuthenticated()

    // сохраняем ID рефовода
    let refId = null
    if (fromParams.has("i") && fromParams.get("i"))
        refId = fromParams.get("i")
    else if (toParams.has("i") && toParams.get("i"))
        refId = toParams.get("i")
    if (refId && !CStorage.getItem("from_ref_id", null)) {
        CStorage.setItem("from_ref_id", refId)
        CStorage.setItem("from_ref_id_created", Math.floor(Date.now() / 1000))
        if (loggedIn) userApi.pushFromRefId()
    }

    // для Android приложений, чтобы конролироват там SPA переходы
    androidRouterBeforeEach(to.fullPath, from.fullPath)

    if (!loggedIn && authRequired) next({path: '/user/signin?return=' + to.path})
    else next()
})

// ручной трекинг посещений, т.к. компонент
// не поддерживает из коробки работу с подпапками
router.afterEach((to, from) => {
    let base = router.options.base
    if (base) base = base.slice(0, -1);
    // do not track page visit if previous and next routes URLs match
    if (to.path == from.path) {
        return
    }
    if (Vue.$metrika) Vue.$metrika.hit(base + to.path, {referer: base + from.path})
})

export default router
